import Login from "../screens/nonAuth/Login.jsx";
import Register from "../screens/nonAuth/Register.jsx";
import Dashboard from "../screens/auth/Dashboard.jsx";
import Home from "../screens/users/Home.jsx";
import About from "../screens/users/About.jsx";
import ForgotPassword from "../screens/nonAuth/ForgotPassword.jsx";
import Profile from "../screens/auth/Profile.jsx";
import NewsBlogs from "../screens/users/NewsBlogs.jsx";
import OurClient from "../screens/users/OurClient.jsx";
import Contact from "../screens/users/Contact.jsx";
import ISO90012015 from "../screens/users/ISO Certificates/ISO90012015.jsx";
import ISO140012015 from "../screens/users/ISO Certificates/ISO140012015.jsx";
import ISO450012018 from "../screens/users/ISO Certificates/ISO450012018.jsx";
import ISO220002018 from "../screens/users/ISO Certificates/ISO220002018.jsx";
import ISO270012013 from "../screens/users/ISO Certificates/ISO270012013.jsx";
import ISO500012011 from "../screens/users/ISO Certificates/ISO500012011.jsx";
import ISO134852016 from "../screens/users/ISO Certificates/ISO134852016.jsx";
import ISO299902010 from "../screens/users/ISO Certificates/ISO299902010.jsx";
import ISO2000012018 from "../screens/users/ISO Certificates/ISO2000012018.jsx";
import CE from "../screens/users/Compliance Certificate/CE.jsx";
import GMP from "../screens/users/Compliance Certificate/GMP.jsx";
import IATF16949 from "../screens/users/Compliance Certificate/IATF16949.jsx";
import Kosher from "../screens/users/Compliance Certificate/Kosher.jsx";
import Haccp from "../screens/users/Compliance Certificate/Haccp.jsx";
import SA8000 from "../screens/users/Compliance Certificate/SA8000.jsx";
import Organic from "../screens/users/Compliance Certificate/Organic.jsx";
import RoHS from "../screens/users/Compliance Certificate/RoHS.jsx";
import Halal from "../screens/users/Compliance Certificate/Halal.jsx";
import BlogDetails from "../screens/users/BlogDetails.jsx";
import Payments from "../screens/users/Payments.jsx";
import Certificates from "../screens/auth/Certificates.jsx";
import Consultants from "../screens/auth/Consultants.jsx";
import OurClients from "../screens/auth/OurClients.jsx";
import Franchise from "../screens/auth/Franchise.jsx";
import Inquiries from "../screens/auth/Inquiries.jsx";
import ApplyForFranchise from "../components/Franchise User Side/ApplyForFranchise.jsx";
import EnquiryForConsultant from "../components/Consultant User Side/EnquiryForConsultant.jsx";
import CertificateExpiryDate from "../components/auth/Expiry/CertificateExpiryDate.jsx";
import FranchiseUser from "../screens/users/FranchiseUser.jsx";
import ConsultantUser from "../screens/users/ConsultantUser.jsx";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/certificates",
    component: <Certificates />,
  },
  {
    path: "/consultants",
    component: <Consultants />,
  },
  {
    path: "/our-client",
    component: <OurClients />,
  },
  {
    path: "/franchise",
    component: <Franchise />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/inquiries",
    component: <Inquiries />,
  },
  {
    path: "/expiry-certificate",
    component: <CertificateExpiryDate />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/news&blogs",
    component: <NewsBlogs />,
  },
  {
    path: "/our-clients",
    component: <OurClient />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/iso-9001:2015",
    component: <ISO90012015 />,
  },
  {
    path: "/iso-14001:2015",
    component: <ISO140012015 />,
  },
  {
    path: "/iso-45001:2018",
    component: <ISO450012018 />,
  },
  {
    path: "/iso-22000:2018",
    component: <ISO220002018 />,
  },
  {
    path: "/iso-27001:2013",
    component: <ISO270012013 />,
  },
  {
    path: "/iso-50001:2011",
    component: <ISO500012011 />,
  },
  {
    path: "/iso-13485:2016",
    component: <ISO134852016 />,
  },
  {
    path: "/iso-29990:2010",
    component: <ISO299902010 />,
  },
  {
    path: "/iso-20000-1:2018",
    component: <ISO2000012018 />,
  },
  {
    path: "/ce",
    component: <CE />,
  },
  {
    path: "/gmp",
    component: <GMP />,
  },
  {
    path: "/iatf16949:2016",
    component: <IATF16949 />,
  },
  {
    path: "/kosher",
    component: <Kosher />,
  },
  {
    path: "/haccp",
    component: <Haccp />,
  },
  {
    path: "/sa8000",
    component: <SA8000 />,
  },
  {
    path: "/organic",
    component: <Organic />,
  },
  {
    path: "/rohs",
    component: <RoHS />,
  },
  {
    path: "/halal",
    component: <Halal />,
  },
  {
    path: "/blogDetails",
    component: <BlogDetails />,
  },
  {
    path: "/payments",
    component: <Payments />,
  },
  {
    path: "/apply-for-franchise",
    component: <FranchiseUser />,
  },
  {
    path: "/consultant-enquiries",
    component: <ConsultantUser />,
  },
];
